import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import {
  ChannelCommunicatorService,
} from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-invitation-register',
  templateUrl: './invitation-register.component.html',
  styleUrls: ['./invitation-register.component.scss'],
})
export class InvitationRegisterComponent implements OnInit {

  isClient = false;
  documentInfo: DocumentModel;
  isCreditCard: any;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private channelCommunicatorService: ChannelCommunicatorService,
  ) {
    this.headerService.show();
  }

  ngOnInit() {
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.isCreditCard = this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_TC;
    if (this.abreCuentasService.getProspectResponse()) {
      this.isClient = this.abreCuentasService.getProspectResponse().client;
    }
  }

  /**
   * summary sign-on completion
   */
  next() {
    // Implement me here :)
    this.navigationService.nextStep();
  }

  goToLink() {
    this.channelCommunicatorService.getImpl().openExternalBrowser('https://www.itau.co', 5, this.abreCuentasService.getPostlogin());
  }

}
